import apiClient from './api';
import { logout as authLogout, setAuthData } from '../utils/auth';

import type { AxiosError } from 'axios';

export const authService = {
  async login(username: string, password: string) {
    try {
      const response = await apiClient.post('/login', {
        username,
        password,
      });
      
      if (response.data.token && response.data.user) {
        setAuthData(response.data.token, response.data.user);
      }
      
      return response;
    } catch (error: unknown) {
      const e = error as AxiosError;
      console.error('Login error details:', {
        status: e.response?.status,
        data: e.response?.data,
        message: e.message,
        url: e.config?.url,
        method: e.config?.method,
        dataSent: e.config?.data
      });
      if (e.code === 'ERR_NETWORK') {
        throw new Error('Unable to connect to the server. Please check if the backend is running.');
      } else if (e.code === 'ECONNREFUSED') {
        throw new Error('Connection refused. Please check if the backend server is running on port 8000.');
      } else if (e.code === 'ETIMEDOUT') {
        throw new Error('Connection timeout. The server is taking too long to respond.');
      }
      throw e;
    }
  },

  async logout() {
    try {
      await apiClient.post('/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      authLogout();
      // Clear the Authorization header
      delete apiClient.defaults.headers.common['Authorization'];
    }
  },

  async getCurrentUser() {
    try {
      const response = await apiClient.get('/users/profile');
      return response.data;
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  }
};
